import { render, staticRenderFns } from "./ZohoChannels.vue?vue&type=template&id=79a6c934&scoped=true"
import script from "./ZohoChannels.vue?vue&type=script&lang=js"
export * from "./ZohoChannels.vue?vue&type=script&lang=js"
import style0 from "./ZohoChannels.vue?vue&type=style&index=0&id=79a6c934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a6c934",
  null
  
)

export default component.exports